// Pakketten en prijzen (standaardlijst + laden uit crm_services). Portering van het losse intake-prototype (TypeScript); logica ongewijzigd.
export const ZORG_CATEGORIE = "Doorlopende zorg";
export const CATEGORIEEN = [
    "Websites en webshops",
    "Eigen software en apps",
    "AI en automatisering",
    "Advies en veiligheid",
];
const p = (slug, naam, prijs, omschrijving, categorie, type = "eenmalig") => ({ slug: `pakket-${slug}`, naam, prijs, omschrijving, categorie, type });
/** Zelfde prijzen als de klantversie (oktober 2026). Dient als terugval en als bron voor de migratie. */
export const STANDAARD_PAKKETTEN = [
    p("website-start", "Website Start", 2950, "Tot 5 pagina's, contactformulier", CATEGORIEEN[0]),
    p("website-pro", "Website Pro", 5500, "Tot 10 pagina's, aanvraagflow, blog, SEO", CATEGORIEEN[0]),
    p("webshop", "Webshop", 7500, "Tot 50 producten, iDEAL, voorraad", CATEGORIEEN[0]),
    p("webshop-plus", "Webshop Plus", 12500, "Tot 500 producten, accounts, leveranciers", CATEGORIEEN[0]),
    p("software-start", "Software Start", 9500, "Eén kernproces, rollen, tot 5 schermen", CATEGORIEEN[1]),
    p("software-pro", "Software Pro", 22500, "Meerdere onderdelen, koppelingen, rapportages", CATEGORIEEN[1]),
    p("software-max", "Software Max", 45000, "Meerdere klanten op één platform, facturatie", CATEGORIEEN[1]),
    p("mobiele-app", "Mobiele app", 24500, "iPhone en Android, beheerpagina", CATEGORIEEN[1]),
    p("ai-automatisering", "AI-automatisering", 2500, "Eén handmatige taak automatiseren", CATEGORIEEN[2]),
    p("ai-medewerker", "AI-medewerker", 8500, "Samenwerkende AI-assistenten met goedkeuring", CATEGORIEEN[2]),
    p("content-machine", "Content-machine", 8500, "Artikelen voorbereiden, goedkeuren, publiceren", CATEGORIEEN[2]),
    p("gegevens-verzamelen", "Gegevens verzamelen", 3950, "Eén soort data ophalen, AVG-proof", CATEGORIEEN[2]),
    p("klanten-werven", "Klanten werven", 12500, "Bedrijven vinden, berichten met goedkeuring", CATEGORIEEN[2]),
    p("plan-van-aanpak", "Plan van aanpak", 1500, "Idee uitwerken tot bouwplan", CATEGORIEEN[3]),
    p("haalbaarheidscheck", "Haalbaarheidscheck", 950, "Doen, aanpassen of niet doen", CATEGORIEEN[3]),
    p("veiligheidscheck", "Veiligheidscheck", 2250, "Database en toegangsrechten", CATEGORIEEN[3]),
    p("veiligheidsaudit", "Uitgebreide veiligheidsaudit", 3950, "Code-review op bekende risico's", CATEGORIEEN[3]),
    p("avg-ai-wetcheck", "AVG- en AI-wetcheck", 2250, "Wat moet de klant regelen", CATEGORIEEN[3]),
    p("zorg-basis", "Zorg Basis", 250, "Hosting, bewaking, updates, 2 uur hulp", ZORG_CATEGORIE, "doorlopend"),
    p("zorg-plus", "Zorg Plus", 600, "Basis plus 6 uur aanpassingen en maandrapport", ZORG_CATEGORIE, "doorlopend"),
    p("zorg-pro", "Zorg Pro", 1200, "Plus 12 uur, voorrang, kwartaalevaluatie", ZORG_CATEGORIE, "doorlopend"),
];
/**
 * Leest de pakketten uit crm_services (slug begint met "pakket-").
 * Regels:
 * - Bekende slug met status "actief": prijs, naam en omschrijving uit de CRM.
 * - Bekende slug met een andere status (concept, gepauzeerd): pakket verdwijnt.
 * - Bekende slug zonder rij: standaardwaarde.
 * - Onbekende "pakket-" slug met geldige prijs: komt onder "Overig".
 * Lukt het lezen niet, dan geldt de standaardlijst.
 */
export async function laadCatalogus(supabase) {
    const { data, error } = await supabase
        .from("crm_services")
        .select("slug,name,description,scope,prijs,status,dienst_type")
        .like("slug", "pakket-%");
    if (error || !data || data.length === 0) {
        return { pakketten: STANDAARD_PAKKETTEN, bron: "standaard" };
    }
    const rijen = new Map(data.map((r) => [r.slug, r]));
    const bekend = new Set(STANDAARD_PAKKETTEN.map((x) => x.slug));
    const uit = [];
    for (const std of STANDAARD_PAKKETTEN) {
        const r = rijen.get(std.slug);
        if (!r) {
            uit.push(std);
            continue;
        }
        if (r.status !== "actief")
            continue;
        const prijs = Number(r.prijs);
        uit.push({
            ...std,
            naam: r.name || std.naam,
            omschrijving: r.description || std.omschrijving,
            prijs: Number.isFinite(prijs) && prijs > 0 ? prijs : std.prijs,
        });
    }
    for (const r of data) {
        if (!r.slug || bekend.has(r.slug) || r.status !== "actief")
            continue;
        const prijs = Number(r.prijs);
        if (!Number.isFinite(prijs) || prijs <= 0)
            continue;
        uit.push({
            slug: r.slug,
            naam: r.name,
            prijs,
            omschrijving: r.description || r.scope || "",
            categorie: "Overig",
            type: r.dienst_type === "doorlopend" ? "doorlopend" : "eenmalig",
        });
    }
    return { pakketten: uit, bron: "crm" };
}
